import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshService {

  private refreshSubject = new Subject<number>();

  refresh$ = this.refreshSubject.asObservable();

  emitRefresh(index: number): void {
    this.refreshSubject.next(index);
  }

  emitRefreshYear(index: number): void {
    this.refreshSubject.next(index);
  }
}
